/**
 * Labstep
 *
 * @module core/Metadata/Variable/Detail
 * @desc Metadata Variable Detail
 */

import { useProtocolConditionModalContext } from 'labstep-web/components/ProtocolCondition/Modal/context';
import { ProtocolConditionProtocolValueVariableSmartTable } from 'labstep-web/components/ProtocolCondition/ProtocolValueVariableSmartTable';
import { GridSmartTableProtocolConditionService } from 'labstep-web/grid/SmartTableProtocolCondition/services/grid-smart-table-protocol-condition.service';
import type React from 'react';
import type { MetadataVariableDetailProps } from './types';

export const MetadataVariableDetail: React.FC<
  MetadataVariableDetailProps
> = ({ protocol, metadata }) => {
  const { isOpen } = useProtocolConditionModalContext();
  if (isOpen) {
    return null;
  }
  return (
    <ProtocolConditionProtocolValueVariableSmartTable
      protocol={protocol}
      defaultColIds={GridSmartTableProtocolConditionService.getDefaultMetadataVariableColIds(
        metadata,
      )}
      name={'Conditions Table'}
    />
  );
};
